<template lang="html">
  <nuxt-link
    v-if="!!isLink"
    :to="to"
  >
    <slot />
  </nuxt-link>
  <span v-else>
    <slot />
  </span>
</template>

<script>
import VueTypes from 'vue-types'

export default {
  props: {
    to: VueTypes.string,
    isLink: {
      type: null, // any
      default: false
    }
  }
}
</script>
